module.exports = __webpack_public_path__ + "media/images/icons/tour-91099938f5b28d6a7205a9eb5bc27b57.svg";